var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyboard-layout",style:(`margin: 0 auto; max-width: ${_vm.maxWidth}`)},_vm._l((_vm.layout),function(row,idx){return _c('KeyRow',{key:idx,attrs:{"row":row,"control_states":_vm.control_states},on:{"layout":e => _vm.$emit('layout', e),"click":_vm.keyClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }